import React from 'react';
import PropTypes from 'prop-types';
import './Boockmark.scss';

const Bookmark = ({ progress, extraClass = '' }) => {
  const last = progress?.vistime?.last;
  if (!last || last?.progress === 0) {
    return null;
  }

  return (
    <div className={`Bookmark ${extraClass}`}>
      <span style={{ border: '0', width: `${last?.progress}%` }} />
    </div>
  );
};

Bookmark.propTypes = {
  progress: PropTypes.shape({
    vistime: PropTypes.shape({
      last: PropTypes.shape({
        progress: PropTypes.number,
      }),
    }),
  }),
  extraClass: PropTypes.string,
};

Bookmark.defaultProps = {
  progress: {
    vistime: {
      last: {
        progress: 0,
      },
    },
  },
};

export default React.memo(Bookmark);
